const formatUserRole = (role: string): string =>
	role
		.trim()
		.toLowerCase()
		.split("_")
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");

export default formatUserRole;
